module.exports = __webpack_public_path__ + "static/media/noto-sans-light.d04dd870.woff";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/fonts/noto-sans-light.woff
// module id = 1113
// module chunks = 0